<template>
    <div id="contentbg">
    <div class="tonglan">
        <div class="yjdjs">
            <!--左侧内容-->
            <div class="yjdleft">
                <a name="a" id="a"></a>
                <h3>医药B2B电商SaaS服务</h3>
                <div class="hzcz">
                    <ul>
                        <li>
                            <a name="b" id="b"></a>

                            合作初衷：药聚多希望运用多年从事医药电商行业，所积累的：
                            一）电商系统开发技术与运营服务管理经验；
                            二）聚合多方的优势品种资源；
                            三）广泛的医药厂商、商业企业圈子，为医药商业企业赋能。
                        </li>
                    </ul>
                </div>
                <div class="fnye">
                    <div class="fnyel">
                        <p><strong class="font16">赋能一：提供品种数据对接</strong></p>
                        <p>
                            目&nbsp;&nbsp;的：将药聚多云仓品种数据与商业公司自有系统对接，迅速丰富商<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业公司的品种资源。可以更好满足客户采购需求，且能实现先<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;销后采，减少库存投入和挤压风险。
                            <br>

                            适合公司：已有线上销售系统，并且使用和运营都比较好的商业公司。
                        </p>
                        <center>
                            <img src="../assets/fn_01.jpg" width="454" height="281">
                        </center>
                    </div>
                    <div class="fnyer">
                        <p><strong class="font16">赋能二：基于云服务提供线上销售系统</strong></p>
                        <p>
                            目&nbsp;&nbsp;的：将云仓数据已接入其中，助力商业公司打造自有电商渠道，<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方便业务员开发终端客户，客户可线上采购；提升业务开发<br>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;效率。
                            <br>

                            适合公司：尚未完善线上销售系统的商业公司。
                        </p>

                        <center>
                            <a name="c" id="c"></a>
                            <img src="../assets/fn_02.jpg" width="410" height="281">
                        </center>

                    </div>

                    <div class="clear" style="height:30px;"></div>
                </div>

                <div class="xtzs">
                    <p><strong class="font16">业务流程</strong></p>
                    <p><center><img src="../assets/hz_03.png" width="960" height="400"></center></p>
                    <p>
                        <strong class="font16">云系统展示：终端客户采购系统界面</strong>
                    </p>
                    <p><center><img src="../assets/hz_06.png" width="960" height="275"></center></p>
                    <p>
                        <strong class="font16">云系统展示：商业管理系统界面</strong>
                    </p>
                    <a name="d" id="d"></a>
                    <p><center><img src="../assets/hz_05.png" width="960" height="286"></center></p>

                </div>

                <p class="xtzs" style="padding-top:30px;"><strong class="font16">合作价值与意义</strong></p>
                <div class="jzyy">
                    <ul>
                        <li style="text-align:left;">
                            <strong>云仓品种接入，解决品种资源不足</strong><br>
                            >>实现先销后采，又不占资金；<br>
                            >>无库存风险。
                        </li>
                        <li style="text-align:left; padding-left:150px; width:330px;">
                            <strong>云服务/系统托管药聚多运维，低成本打造电商渠道</strong><br>
                            >>无需高薪聘请技术和运维人员；<br>
                            >>省却网络、硬件、机房设施的投入。
                        </li>
                        <li style="text-align:left;">
                            <strong>提升业务开发的效率</strong><br>
                            >>通过线上加强与客户联系，线上营销、下单等；<br>
                            >>移动APP，可随时随地开发和处理业务。
                        </li>
                        <li style="text-align:left; padding-left:150px; width:330px;">
                            <strong>成为药聚多商业联盟成员</strong><br>
                            >>扩大医药资源圈<br>
                            >>共享业内优质资源
                        </li>
                    </ul>
                </div>
                <a name="e" id="e"></a>
                <div>
                    <ul>
                        <li>
                            <p><strong class="font16">加盟咨询</strong></p>
                            <p>
                                付经理：18356878553 &nbsp; 广东、广西、青海、贵州、四川、黑龙江、辽宁、内蒙古<br>

                                齐经理：15655873330 &nbsp; 山东、海南、西藏、河北、湖北、湖南、江苏、甘肃、天津、陕西<br>

                                宋经理：13866202981 &nbsp; 浙江、江西、山西、上海、吉林<br>

                                张经理：15755835088 &nbsp; 福建、新疆、北京、宁夏、重庆、云南、河南、安徽<br>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="yjdright">
                <div class="gywmbg">
                    <ul>
                        <li class="libg white">医药B2B电商服务</li>
                    </ul>
                </div>
                <div class="ywjsbg">
                    <ul>
                        <li><a href="#a">合作初衷</a></li>
                        <li><a href="#b">两项赋能</a></li>
                        <li><a href="#c">业务流程</a></li>
                        <li><a href="#d">合作价值与意义</a></li>
                        <li><a href="#e">加盟咨询</a></li>
                    </ul>
                </div>
            </div>
            <div class="clear"></div>
            <div class="yjdleft" id="yj2" style="display:none">
                <h3>系统工具介绍</h3>
                <ul>
                    <li>
                        <p>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医药销售管理系统为创业者从电子商务平台采购药品的操作系统。该
                            系统实现对创业者下属终端销售网络的管理、库存品种的管理、药品的价格管理、创业者终端的订单管理以及资金管理、物流管理。
                            <br><br>
                            1.客户管理------客户管理是销售和采购系统的核心，一切操作都需要围绕终端客户展开。
                            <br><br>
                            2.品种管理------创业者在第三方电子商务平台产品数据库中选择适合该终端的药品。
                            <br><br>
                            3.价格管理------针对不同终端的消费能力，在挑选品种的基础上，最终实现价格差异。
                            <br><br>
                            4.订单管理------创业者的终端提交了需求订单，就可以在此项中处理。
                            <br><br>
                            5.资金管理------资金管理中，创业者可以详细的查看，交易情况。
                            <br><br>
                            6.物流管理-----实现订单从下单，到支付，到出库，到物流的全程订单查看。让创业者充分享有订单的知情权，方便把控终端。
                            <br><br>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;终端采购系统是终端（药店、医院、卫生院）向创业者进行药品采购
                            行为的操作系统。终端看到的所有药品信息都是创业者提供的。最终，终端通过该平台实现产品信息查询、在线订购、缺货登记、资料修改等行为。
                            <br><br>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;供应商系统的适用者为电子商务平台的合作伙伴（一般包括医药生产
                            厂家、医药代理商），主要职能包括对代理药品的销售数据查看、相关数据分析等。
                        </p>
                    </li>
                </ul>
            </div>
            <div class="yjdleft" id="yj3" style="display:none">
                <h3>创业者模式特点</h3>
                <ul>
                    <li>
                        <p>
                            1、创新医药营销渠道，为药品分销引入“互联网+ ”行动力；
                            <br><br>
                            2、医药创业者平台，扁平化管理，减少流通链，提高经营效率；
                            <br><br>
                            3、利用创业者平台,瞬间成为5万多个品规在当地的一级代理商，医药创业者模式先进的电子商务系统，改传统医药分销行商模式为坐商模式；
                            <br><br>
                            4、利用医药创业者平台对医药创业者提供全程服务（包括售前培训、品种选择、市场开拓、售后服务）；
                            <br><br>
                            5、医药创业者模式规模效应，对药企和药品总代合作更具话语权，创业者将成为当地药品市场的开拓者、组织者和领导者。
                            <br><br>
                            6、医药创业者联盟，加速创业者成长，助力创业者腾飞。
                        </p>
                    </li>
                </ul>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  name: 'B2B'
}
</script>
